/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import * as _ from "lodash";
import WorkerTimer from "@/plugins/WorkerTimer";
import {uuid} from "vue-uuid";

export default {
	state: () => ({
		defaults: {
			active: false,
			type: null,
			title: "",
			message: "",
			action: null,
			timeout: 7000
		},

		snackbarNotification: null,

		notifications: [],

		persistentNotifications: null,

		syncToSelectionActive: false
	}),

	getters: {
		snackbarNotification: (state) => () => {
			return state.snackbarNotification;
		},

		getNotifications: (state) => () => {
			return state.notifications;
		},

		persistentNotifications: (state) => () => {
			return state.persistentNotifications;
		},

		getSyncToSelectionActive: (state) => () => {
			return state.syncToSelectionActive;
		}
	},

	mutations: {
		SHOW_SUCCESS_NOTIFICATION(state, payload) {
			state.snackbarNotification = {...state.defaults, ...payload, id: payload.id ?? uuid.v1(), type: "success", active: true};
		},

		SHOW_NOTIFICATION_WITH_TYPE(state, payload) {
			state.notifications.forEach(n => n.active = false);
			const message = {...state.defaults, ...payload, id: uuid.v1(), type: payload.type ?? "CriticalAlert", active: true};
			state.notifications.unshift(message);

			WorkerTimer.setTimeout(() => {
				const index = state.notifications.findIndex(n => n.id === message.id);
				if (index > -1) {
					state.notifications[index].active = false;
				}
			}, message.timeout);
		},

		SHOW_PERSISTENT_NOTIFICATION(state, payload) {
			state.persistentNotifications = {...state.defaults, ...payload, id: payload.id ?? uuid.v1(), type: payload.type, active: true};
		},

		UPDATE_PERSISTENT_NOTIFICATION(state, payload) {
			state.persistentNotifications = {...state.persistentNotifications, ...payload};
		},

		SHOW_NOTIFICATION_WITH_ACTION(state, payload) {
			state.snackbarNotification = {...state.defaults, ...payload, id: uuid.v1(), type: "action", active: true};
		},

		HIDE_NOTIFICATION(state, notification) {
			switch (notification.type) {
				case "success":
				case "action":
					state.snackbarNotification.active = false;
					break;
				default:
					_.find(state.notifications, notification).active = false;
			}
		},

		REMOVE_PERSISTENT_NOTIFICATION(state) {
			state.persistentNotifications = {};
		},

		REMOVE_NOTIFICATION(state, notification) {
			state.notifications.splice(
				_.findIndex(state.notifications, notification),
				1
			);
		},

		REMOVE_ALL_NOTIFICATIONS(state) {
			state.notifications = [];
		},

		setSyncToSelectionActive(state, active) {
			state.syncToSelectionActive = active;
		}
	}
};
